(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-retailer-login/assets/javascripts/login.js') >= 0) return;  svs.modules.push('/modules/lb-retailer-login/assets/javascripts/login.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useRef = _React.useRef;
const _svs$core = svs.core,
  jupiter = _svs$core.jupiter,
  session = _svs$core.session,
  deviceSession = _svs$core.deviceSession;
const Button = svs.ui.Button;
const Input = svs.ui.form.Input;
const source = svs.lb_retailer_login.data.source;
const url = svs.lb_retailer_login.data.login.url;
const _svs$components$dialo = svs.components.dialog,
  Confirm = _svs$components$dialo.Confirm,
  branding = _svs$components$dialo.branding,
  message = _svs$components$dialo.message,
  api = _svs$components$dialo.api,
  type = _svs$components$dialo.type;
const getLogger = svs.core.log.getLogger;
const logger = getLogger('lb-retailer-login');
const saveLastLoginTime = (lastLoginTime, cb) => {
  if (lastLoginTime) {
    deviceSession.set('lastLoginTime', null, lastLoginTime, cb);
  } else if (Object.prototype.hasOwnProperty.call(session.data.session, 'lastLoginTime')) {
    deviceSession.remove('lastLoginTime', null, cb);
  } else {
    cb();
  }
};

const saveUserNotifications = (notif, cb) => {
  if (notif && notif.REDIRECT) {
    deviceSession.set('userNotifications', null, {
      redirect: true
    }, cb);
  } else if (Object.prototype.hasOwnProperty.call(session.data.session, 'userNotifications')) {
    deviceSession.remove('userNotifications', null, cb);
  } else {
    cb();
  }
};

const saveSequenceNumber = (sequenceNum, cb) => {
  if (Number.isInteger(sequenceNum) && sequenceNum > -1) {
    deviceSession.set('sequencenumber', null, sequenceNum, cb);
  } else if (Object.prototype.hasOwnProperty.call(session.data.session, 'sequencenumber')) {
    deviceSession.remove('sequencenumber', null, cb);
  } else {
    cb();
  }
};
const Login = _ref => {
  let history = _ref.history;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    retailerId = _useState2[0],
    setRetailerId = _useState2[1];
  const _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    retailerUsername = _useState4[0],
    setRetailerUsername = _useState4[1];
  const _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    retailerPassword = _useState6[0],
    setRetailerPassword = _useState6[1];
  const retailerPasswordEl = useRef(null);
  const _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    errorMessage = _useState8[0],
    setErrorMessage = _useState8[1];
  function handleSubmit(e) {
    e.preventDefault();
    function onLoginSuccess(result) {
      logger.info("retailerLogin: ".concat(result.session.retailerId, " logged in"));
      const _result$userNotificat = result.userNotifications,
        _result$userNotificat2 = _result$userNotificat === void 0 ? {} : _result$userNotificat,
        mustChangePwd = _result$userNotificat2.REDIRECT;
      if (mustChangePwd) {
        history.replace("/byt-losenord?returnUrl=".concat(url));
        return;
      }
      saveLastLoginTime(result.lastLoginTime, () => {
        saveUserNotifications(result.userNotifications, () => {
          saveSequenceNumber(result.sequenceNum, () => {
            location.href = url;
          });
        });
      });
    }
    function onLoginError(response) {
      let errorCode = -1;
      let errorMessage;
      let dialogTitle;
      let shouldShowDialog = true;
      const showDialog = _ref2 => {
        let theMessage = _ref2.theMessage,
          title = _ref2.title;
        const dialog = new Confirm({
          branding: branding.SPORT,
          type: type.ERROR,
          title: title || 'Tekniskt fel',
          message: [{
            type: message.TEXT,
            text: theMessage || 'Var vänlig försök igen senare.'
          }],
          actions: [{
            title: 'Stäng',
            callback: () => {
              dialog.close();
            }
          }]
        });
        api.add(dialog);
      };
      if (response.responseText) {
        errorCode = JSON.parse(response.responseText).error.code;
        logger.info("retailerLogin: Error login ".concat(errorCode));
      } else {
        logger.info('retailerLogin: Error login probably timeouterror');
      }
      switch (errorCode) {
        case 2: 
        case 13:
          shouldShowDialog = false;
          setErrorMessage('Fel lösenord eller användarnamn');
          retailerPasswordEl.current.focus();
          retailerPasswordEl.current.select();
          break;
        case 5:
          dialogTitle = 'Kontot är låst';
          errorMessage = 'Ditt lösenord är nu ogiltigt på grund av många felaktiga inloggningsförsök.<br/>Kontakta ombudssupport 020-78 83 55';
          break;
        case 6:
          setErrorMessage('Spärrat konto');
          dialogTitle = 'Inloggning misslyckades';
          errorMessage = 'Ditt konto är spärrat.<br/>Vid frågor, kontakta ombudssupport 020-78 83 55';
          break;
        default:
          dialogTitle = 'Något gick fel';
          errorMessage = 'Ett oväntat fel inträffade.<br/>Vid frågor, kontakta ombudssupport 020-78 83 55';
      }
      if (shouldShowDialog) {
        showDialog({
          theMessage: errorMessage,
          title: dialogTitle
        });
      }
    }
    let fixedId = retailerId;
    if (retailerId[0] === '0') {
      fixedId = retailerId.slice(1);
    }
    const options = {
      path: '/retailer/1/sessions/webterminal',
      data: {
        userName: fixedId + retailerUsername,
        password: retailerPassword,
        source
      },
      useExtErrFunc: false
    };
    jupiter.post(options, onLoginSuccess, onLoginError);
  }
  return React.createElement("div", {
    className: "bg-white border-grey-300 padding-3 margin-bottom-2",
    style: {
      width: 465,
      borderWidth: 1,
      borderStyle: 'solid',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: 4
    }
  }, React.createElement("form", {
    className: "control-group".concat(errorMessage ? ' error' : '', " margin-bottom-0"),
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-800 margin-bottom-1",
    style: {
      fontSize: 22
    }
  }, "Ombud - Logga in"), React.createElement("div", {
    className: "control-group"
  }, React.createElement("label", {
    htmlFor: "retailer_id"
  }, "OMBUDSNUMMER (ENDAST SIFFROR)"), React.createElement(Input, {
    className: "qa-retailer-id",
    id: "retailer_id",
    onChange: e => setRetailerId(e.target.value.replace(/\D/g, '').trim()),
    pattern: "[0-9]+",
    placeholder: "ex. 1234567",
    required: true,
    type: "text",
    value: retailerId
  })), React.createElement("div", {
    className: "control-group"
  }, React.createElement("label", {
    htmlFor: "retailer_username"
  }, "ANV\xC4NDARNAMN (SAMMA SOM I TERMINALEN)"), React.createElement(Input, {
    className: "qa-retailer-username",
    id: "retailer_username",
    minLength: 2,
    onChange: e => setRetailerUsername(e.target.value.trim()),
    placeholder: "ex. Emma Eriksson",
    required: true,
    type: "text",
    value: retailerUsername
  })), React.createElement("div", {
    className: "control-group margin-bottom-2"
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "retailer_password"
  }, "L\xD6SENORD (SAMMA SOM I TERMINALEN)"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-retailer-password",
    id: "retailer_password",
    onChange: e => setRetailerPassword(e.target.value),
    ref: retailerPasswordEl,
    required: true,
    type: "password",
    value: retailerPassword
  })), React.createElement("div", {
    className: "error-message"
  }, errorMessage)), React.createElement(Button, {
    block: true,
    className: "qa-login",
    focus: true,
    type: "submit"
  }, "Logga in")));
};
setGlobal('svs.lb_retailer_login.Login', Login);

 })(window);